import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AdminPage.css';
import { ReactComponent as BackIcon } from '../assets/back.svg';

const AdminPage: React.FC = () => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [title, setTitle] = useState('');
  const [attendants, setAttendants] = useState([{ name: '', ral: 0 }]);

  useEffect(() => {
    const savedTitle = localStorage.getItem('title') || '';
    const savedAttendants = JSON.parse(localStorage.getItem('attendants') || '[]');
    setTitle(savedTitle);
    setAttendants(savedAttendants);
  }, []);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'prova123') {
      setIsAuthenticated(true);
    }
  };

  const handleAddAttendant = () => {
    setAttendants([...attendants, { name: '', ral: 0 }]);
  };

  const handleRemoveAttendant = (index: number) => {
    const newAttendants = attendants.filter((_, i) => i !== index);
    setAttendants(newAttendants);
  };

  const handleSave = () => {
    localStorage.setItem('title', title);
    localStorage.setItem('attendants', JSON.stringify(attendants));
  };

  return (
    <div className="admin-page">
      <Link to="/" className="back-link">
        <BackIcon />
      </Link>
      {!isAuthenticated ? (
        <form onSubmit={handleLogin} className="login-form">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
          />
          <button type="submit">Login</button>
        </form>
      ) : (
        <div>
          <label htmlFor="title">Titolo della riunione</label>
          <input
            id="title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Titolo della riunione"
          />
          <hr />
          {attendants.map((attendant, index) => (
            <div key={index} className="attendant-line">
              <label htmlFor={`name-${index}`}>Nome</label>
              <input
                id={`name-${index}`}
                type="text"
                value={attendant.name}
                onChange={(e) => {
                  const newAttendants = [...attendants];
                  newAttendants[index].name = e.target.value;
                  setAttendants(newAttendants);
                }}
                placeholder="Nome"
              />
              <label htmlFor={`ral-${index}`}>RAL</label>
              <input
                id={`ral-${index}`}
                type="number"
                value={attendant.ral}
                onChange={(e) => {
                  const newAttendants = [...attendants];
                  newAttendants[index].ral = parseInt(e.target.value);
                  setAttendants(newAttendants);
                }}
                placeholder="RAL"
              />
              <button onClick={() => handleRemoveAttendant(index)}>Rimuovi</button>
            </div>
          ))}
          <button onClick={handleAddAttendant}>Aggiungi partecipante</button>
          <button onClick={handleSave}>Salva</button>
        </div>
      )}
    </div>
  );
};

export default AdminPage;
